import { Avatar, Flex, Tooltip } from '@chakra-ui/react';
import NavLink from '@components/layout/NavigationBar/DesktopNavigation/NavLink';
import { fsmTeam } from '@constants/fsmTeam';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { Mode, ModeToColor, useMode } from '@contexts/ModeContextProvider';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../../crm/lead/shared/IconButton';
import BedrockLinks from './BedrockLinks';
import FsmLinks from './FsmLinks';

export default function BedrockNavbar() {
  // Resources
  const { localUser, authenticatedUser: agent, isBedrock, isAgent, handleLogout } = useAuthenticatedContextProvider();
  const mode = useMode();

  // Get the agent info for the logged-in agent using the calendly slug.
  const agentInfo =
    agent &&
    agent?.agent_profile?.scheduling_system_slug &&
    fsmTeam.find((member) => member.calendly === agent?.agent_profile?.scheduling_system_slug);

  let agentName = '';
  if (agentInfo?.name) {
    agentName = agentInfo.name;
  } else if (agent?.first_name) {
    agentName = `${agent.first_name} ${agent.last_name}`;
  }

  // Flags
  const showSwitchUser = !isAgent && localUser?.multipleUsers?.length > 1;

  return (
    <Flex
      borderBottom="1px solid"
      borderBottomWidth={mode === Mode.DEFAULT ? 1 : 3}
      borderColor={mode === Mode.DEFAULT ? 'gray.300' : ModeToColor[mode]}
      fontWeight={600}
      py={2}
      px={10}
      justifyContent="space-between"
      userSelect="none"
      bgColor="white"
    >
      <Flex alignItems="center">{isBedrock ? <BedrockLinks /> : <FsmLinks />}</Flex>
      <Flex alignItems="center" gap={3}>
        {isAgent && (
          <Tooltip label={agentName}>
            <Avatar
              size="sm"
              bg="gray.400"
              name={agentName}
              src={agentInfo && agentInfo.image.src}
              fontWeight={600}
              color="white"
            />
          </Tooltip>
        )}
        <Flex gap={4} alignItems="center">
          {showSwitchUser && <NavLink href={Routes.chooseAccount} text="Switch User" />}
          {isAgent && <IconButton label="Sign out" onClick={handleLogout} icon={faSignOut} size="sm" />}
        </Flex>
      </Flex>
    </Flex>
  );
}
